// ---------------------------------------------------------------------------
// API endpoints — single source of truth.
//
// Switch between local and live by setting REACT_APP_HOST_API in a `.env` file
// at the frontend root (then restart `npm start` — CRA only reads .env on boot):
//
//   Local:  REACT_APP_HOST_API=http://127.0.0.1:8000/api/
//   Live:   REACT_APP_HOST_API=https://portal.grapetask.co/api/
//
// If REACT_APP_HOST_API is not set, it falls back to the live server.
// ---------------------------------------------------------------------------

const FALLBACK_API = "https://portal.grapetask.co/api/";

export const HOST_API = process.env.REACT_APP_HOST_API || FALLBACK_API;

// BACKEND_BASE = HOST_API without the trailing `/api/` (used for assets, storage, etc.)
export const BACKEND_BASE =
  process.env.REACT_APP_BACKEND_BASE || HOST_API.replace(/\/api\/?$/, "");

export const PUSHER_HOST = `${BACKEND_BASE}/broadcasting/auth`;

// MEDIA_BASE = where static marketing assets / uploaded images live.
// These only exist on the live server, so this stays on live even in local dev
// (otherwise login-slider images, avatars, sounds would 404 locally).
// Override with REACT_APP_MEDIA_BASE if you mirror assets elsewhere.
export const MEDIA_BASE =
  process.env.REACT_APP_MEDIA_BASE || "https://portal.grapetask.co";
